import { SUGGESTION_SET_DATA } from '../constants/suggestionConstants';

export const setData = (data) => (dispatch) => {
  dispatch({
    type: SUGGESTION_SET_DATA,
    payload: data,
  });
};
